// extracted by mini-css-extract-plugin
export default {"root":"controlButton-module__root--_I2DY","left":"controlButton-module__left--iaz7c","right":"controlButton-module__right--JIpI2"};